import React, { useEffect, useMemo, useState } from 'react';
import { createPortal } from 'react-dom';
import { useSelector } from 'react-redux';
import ProductListViewCard from './ProductListViewCard';
import LoadMoreProductsContainer from '../Containers/LoadMoreProductsContainer';

const CategoryProductsListView = () => {
  const { productsWrapper, isLoading } = useSelector(
    (state) => state.productsView
  );
  const { products, pagination, categorySystemId } = productsWrapper;
  const type = categorySystemId ? 'category' : 'search';
  const filters = useSelector((state) => state.facetedSearch.facetFilters);
  const allSelectedOptions = useMemo(() => {
    return filters.reduce((accumulator, filter) => {
      if (Array.isArray(filter.selectedOptions) && filter.selectedOptions.length > 0) {
        const { id, selectedOptions } = filter;
        accumulator[id] = selectedOptions;
      }
      return accumulator;
    }, {});
  }, [filters]);

  const productsRender = useMemo(
    () =>
      products.map((product) => (
        <li
          className="product-list__item"
          key={product.id + 'categoryproductlist'}
        >
          <ProductListViewCard {...product} />
        </li>
      )),
    [products]
  );
  return (
    <>
      <ul className="product-list-listview">{productsRender}</ul>
      <div className="load-more-products">
        <LoadMoreProductsContainer
          {...pagination}
          identifier={categorySystemId}
          type={type}
          products={productsWrapper}
          filters={allSelectedOptions}
        />
      </div>
    </>
  );
};
export default CategoryProductsListView;
